import Vue from 'vue';
import Resumable from 'resumablejs';
import { v4 as uuidv4 } from 'uuid';

import appSettingsProvider from '@/appsettings';

export function buildResumable() {
  const resumable = new Resumable({
    generateUniqueIdentifier: () => uuidv4()
  });
  appSettingsProvider.then(appSettings => (resumable.opts.target = `${appSettings.files.url}/upload`));
  resumable.on('fileAdded', file => {
    Vue.set(file, 'tsUploadProgress', file.progress());
    Vue.set(file, 'tsIsComplete', file.isComplete());
    Vue.set(file, 'tsIsUploading', file.isUploading());
  });
  resumable.on('fileProgress', file => {
    Vue.set(file, 'tsUploadProgress', file.progress());
    Vue.set(file, 'tsIsComplete', file.isComplete());
    Vue.set(file, 'tsIsUploading', file.isUploading());
  });
  return resumable;
}

export default {
  data() {
    return {
      resumable: buildResumable()
    };
  }
};
